import {createAction} from '@reduxjs/toolkit'
import {IdCategoriesStateDataItem, typeCategoriesFilters} from './dCategoriesReducer'
import {typePagination, typeRequestPagination} from "../system/constants";




// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set data
export const dCategoriesSetDataAC = createAction(
    'D_CATEGORIES_SET_DATA',
    (dataObject: IdCategoriesStateDataItem[]) => ({payload: dataObject})
)

// Action creator of saga set data
export const dCategoriesSetDataSagaAC = createAction(
    'D_CATEGORIES_SET_DATA_SAGA',
    (
        filters: typeCategoriesFilters,
        paginationRequest: typeRequestPagination
    ) => ({payload: { filters, paginationRequest}})
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set item to data
export const dCategoriesSetDetailItemAC = createAction(
    'D_CATEGORIES_SET_DETAIL_ITEM',
    (detailItemId: string) => ({payload: detailItemId})
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of edit item
export const dCategoriesEditItemAC = createAction(
    'D_CATEGORIES_EDIT_ITEM',
    (detailItemObject: IdCategoriesStateDataItem) => ({payload: detailItemObject})
)

// Action creator of saga edit item
export const dCategoriesEditItemSagaAC = createAction(
    'D_CATEGORIES_EDIT_SAGA_ITEM',
    (
        filters: typeCategoriesFilters ,
        paginationRequest: typeRequestPagination
    ) => ({payload: { filters, paginationRequest}})
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of add item
export const dCategoriesAddItemAC = createAction(
    'D_CATEGORIES_ADD_ITEM',
    (detailItemObject: IdCategoriesStateDataItem) => ({payload: detailItemObject})
)

// Action creator of saga add item
export const dCategoriesAddItemSagaAC = createAction(
    'D_CATEGORIES_ADD_SAGA_ITEM',
    (
        filters: typeCategoriesFilters,
        paginationRequest: typeRequestPagination
    ) => ({payload: { filters, paginationRequest}})
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of delete item
export const dCategoriesDeleteItemAC = createAction(
    'D_CATEGORIES_DELETE_ITEM',
    (itemId: string) => ({payload: itemId, })
)

// Action creator of saga delete item
export const dCategoriesDeleteItemSagaAC = createAction(
    'D_CATEGORIES_DELETE_SAGA_ITEM',
    (
        itemId: string,
        filters: typeCategoriesFilters,
        paginationRequest: typeRequestPagination
    ) => ({payload: {itemId, filters, paginationRequest}})
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of bulk delete
export const dCategoriesBulkDeleteSagaAC = createAction(
    'D_CATEGORIES_BULK_DELETE_SAGA',
    (
        bulkIds: string[],
        filters: typeCategoriesFilters,
        paginationRequest: typeRequestPagination
        ) => ({payload: { bulkIds, filters, paginationRequest}})
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of saga bulk recover
export const dCategoriesRecoverBulkSagaAC = createAction(
    'D_CATEGORIES_RECOVER_BULK_SAGA',
    (
        bulkIds: string[] ,
        filters: typeCategoriesFilters,
        paginationRequest: typeRequestPagination
    ) => ({payload: { bulkIds, filters, paginationRequest}})
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of clear filtersForm
export const dCategoriesClearFiltersAC = createAction(
    'D_CATEGORIES_CLEAR_FILTERS',
)

// Action creator of set filtersForm
export const dCategoriesSetFiltersAC = createAction(
    'D_CATEGORIES_SET_FILTERS',
    (filterObj: typeCategoriesFilters) => ({payload: filterObj})
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set checked item
export const dCategoriesCheckedItemAC = createAction(
    'D_CATEGORIES_CHECK_ITEM',
    (itemId: string) => ({payload: itemId})
)

// Action creator of checked all items
export const dCategoriesCheckedAllItemAC = createAction(
    'D_CATEGORIES_CHECK_ALL_ITEM',
    (value: boolean) => ({payload: value})
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set pagination
export const dCategoriesSetPaginationAC = createAction(
    'D_CATEGORIES_SET_PAGINATION',
    (
        pagination: typePagination,
    ) => ({payload: {pagination}})
)

// Action creator of set pageNumber in pagination
export const dCategoriesSetPageNumberAC = createAction(
    'D_CATEGORIES_SET_PAGE_NUMBER',
    (
        pageNumber: number,
    ) => ({payload: {pageNumber}})
)


// Action creator of set itemsForPage in pagination
export const dCategoriesSetItemsForPageAC = createAction(
    'D_CATEGORIES_SET_ITEMS_FOR_PAGE',
    (
        itemsForPage: number,
    ) => ( { payload: { itemsForPage } } )
)
